module.exports = __webpack_public_path__ + "static/img/visa_bg_study_abroad.62b7fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/products/visa_bg_study_abroad.png
// module id = M4ko
// module chunks = 4